import Swiper from 'swiper/bundle';
import helpers from './helpers.js';

/*
===========================================
Gallery
===========================================
*/
export default (function () {
  return {
    init() {
      if (document.querySelector('.js-gallery-swiper')) {
        const selects = document.querySelectorAll('.js-gallery-swiper');
        helpers.forEach(selects, (index, element) => {
          // eslint-disable-next-line no-new
          const thumbs = element.querySelector('.js-gallery-swiper-thumbs');
          const gallery = element.querySelector('.js-gallery-swiper-top');

          const galleryThumbs = new Swiper(thumbs, {
            spaceBetween: 10,
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            slideThumbActiveClass: 'gallery-swiper__thumb-slide--active',
            thumbsContainerClass: 'gallery-swiper-thumbs',
            slideClass: 'gallery-swiper__thumb-slide',
            slideActiveClass: 'gallery-swiper__thumb-slide-active',
            slideDuplicateActiveClass: 'gallery-swiper__thumb-slide-duplicate-active',
            slideVisibleClass: 'gallery-swiper__thumb-slide-visible',
            slideDuplicateClass: 'gallery-swiper__thumb-slide-duplicate',
            slideNextClass: 'gallery-swiper__thumb-slide-next',
            slideDuplicateNextClass: 'gallery-swiper__thumb-slide-duplicate-next',
            slidePrevClass: 'gallery-swiper__thumb-slide-prev',
            slideDuplicatePrevClass: 'gallery-swiper__thumb-slide-duplicate-prev',
            wrapperClass: 'gallery-swiper__wrapper',
            // centeredSlides: true,
            zoom: false,
            draggable: false,
          });

          const galleryTop = new Swiper(gallery, {
            zoom: {
              zoomedSlideClass: 'swiper-zoom-target',
              toggle: true,
            },
            spaceBetween: 0,
            containerModifierClass: 'gallery-swiper__container-',
            slideClass: 'gallery-swiper__slide',
            slideActiveClass: 'gallery-swiper__slide-active',
            slideDuplicateActiveClass: 'gallery-swiper__slide-duplicate-active',
            slideVisibleClass: 'gallery-swiper__slide-visible',
            slideDuplicateClass: 'gallery-swiper__slide-duplicate',
            slideNextClass: 'gallery-swiper__slide-next',
            slideDuplicateNextClass: 'gallery-swiper__slide-duplicate-next',
            slidePrevClass: 'gallery-swiper__slide-prev',
            slideDuplicatePrevClass: 'gallery-swiper__slide-duplicate-prev',
            wrapperClass: 'gallery-swiper__wrapper',
            navigation: {
              nextEl: '.gallery-swiper__control--next',
              prevEl: '.gallery-swiper__control--prev ',
            },
            thumbs: {
              swiper: galleryThumbs,
            },
            keyboard: {
              enabled: true,
              onlyInViewport: false,
            },
          });
        });
      }
    },
  };
}());
